import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { TemplateId } from 'data/templates/api';
import { ProjectTemplateSprint, ProjectTemplateStore } from '../types';
import { useActiveTemplateId } from './use-active-project-template';

const getAllSprintsSelector = () =>
  createSelector(
    (state: RootState) => state.templates.project,
    (_, templateId: TemplateId) => templateId,
    (
      project: ProjectTemplateStore,
      templateId,
    ): { [key: string]: ProjectTemplateSprint } =>
      project.data[templateId].sprints,
  );

export const useGetAllSprints = (): {
  [key: string]: ProjectTemplateSprint;
} => {
  const templateId = useActiveTemplateId();
  const templateObject = useMemo(getAllSprintsSelector, []);

  return useSelector((state: RootState) => templateObject(state, templateId));
};
